import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, signOut, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-palette-line text-white text-xl"></i>
            </div>
            <span className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Akash Graphic
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap">
              Home
            </Link>
            <Link to="/shop" className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap">
              Shop
            </Link>
            <Link to="/portfolio" className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap">
              Portfolio
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap">
              Contact
            </Link>
            
            {user ? (
              <div className="flex items-center gap-4">
                {isAdmin && (
                  <Link
                    to="/admin"
                    className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg hover:from-purple-600 hover:to-purple-700 transition whitespace-nowrap"
                  >
                    <i className="ri-dashboard-line"></i>
                    Admin
                  </Link>
                )}
                <Link
                  to="/account"
                  className="flex items-center gap-2 text-gray-700 hover:text-teal-500 transition whitespace-nowrap"
                >
                  <i className="ri-user-line"></i>
                  Account
                </Link>
                <button
                  onClick={handleSignOut}
                  className="flex items-center gap-2 text-gray-700 hover:text-red-500 transition whitespace-nowrap"
                >
                  <i className="ri-logout-box-line"></i>
                  Logout
                </button>
              </div>
            ) : (
              <Link
                to="/login"
                className="px-6 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition whitespace-nowrap"
              >
                Login
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/shop"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap"
              >
                Shop
              </Link>
              <Link
                to="/portfolio"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap"
              >
                Portfolio
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 hover:text-teal-500 transition whitespace-nowrap"
              >
                Contact
              </Link>
              
              {user ? (
                <>
                  {isAdmin && (
                    <Link
                      to="/admin"
                      onClick={() => setIsMenuOpen(false)}
                      className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg hover:from-purple-600 hover:to-purple-700 transition whitespace-nowrap"
                    >
                      <i className="ri-dashboard-line"></i>
                      Admin Dashboard
                    </Link>
                  )}
                  <Link
                    to="/account"
                    onClick={() => setIsMenuOpen(false)}
                    className="flex items-center gap-2 text-gray-700 hover:text-teal-500 transition whitespace-nowrap"
                  >
                    <i className="ri-user-line"></i>
                    My Account
                  </Link>
                  <button
                    onClick={handleSignOut}
                    className="flex items-center gap-2 text-gray-700 hover:text-red-500 transition text-left whitespace-nowrap"
                  >
                    <i className="ri-logout-box-line"></i>
                    Logout
                  </button>
                </>
              ) : (
                <Link
                  to="/login"
                  onClick={() => setIsMenuOpen(false)}
                  className="px-6 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition text-center whitespace-nowrap"
                >
                  Login
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
